import React, { useContext } from 'react'
import './Load.scss'
import MyContext from '../../Uttis/MyContext'
import logo from '../../assets/logo/white_logo.png';

const MyLoad = () => {
    const {loading} = useContext(MyContext)
  return (

    <>
    {loading &&
    <div className={`loader-container ${loading ? 'loading' : ''}`}>
      
      <div className="loader-ring">
        <img src={logo} alt="V-Ex Logo" className="logo-img" />
      </div>
    </div>
    }
    </>
  )
}

export default MyLoad